<template>
<div class="watermark-container">
	<div class="watermark-content">
		<div class="watermark-text" v-for="item in 100" :key="item">
			<div>{{ content }}</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	props:{
		content: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			
		};
	},
	created() {
		
	},
	methods: {
		
	}
};
</script>
<style lang="less" scoped>
.watermark-container {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	// z-index: -1;
	overflow: hidden;
	.watermark-content {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		position: absolute;
		left: -20%;
		right: -20%;
		top: -10%;
		bottom: -10%;
		.watermark-text {
			line-height: 18px;
			transform: rotate(-30deg);
			margin: 0 40px;
			margin-bottom: 80px;
			text-align: center;
			font-size: 14px;
			color: #a5a5a5;
			letter-spacing: 1px;
			white-space: nowrap;
			opacity: 0.2;
		}
	}
}
</style>
